import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { setError("6 caractères minimum"); return; }
    if (pw !== pw2) { setError("Les mots de passe ne correspondent pas"); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/set-password", { token, password: pw });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Lien invalide, expiré ou déjà utilisé");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-2xl bg-white border border-slate-200 shadow-sm flex items-center justify-center overflow-hidden">
            <img src="/logo.png" alt="HSH Ops" className="w-10 h-10 object-contain" />
          </div>
          <div>
            <h1 className="text-lg font-bold font-display text-slate-900">HSH Ops</h1>
            <p className="text-xs text-slate-500">Gestion opérationnelle</p>
          </div>
        </div>
        {done ? (
          <div className="text-center" data-testid="set-password-success">
            <h2 className="text-2xl font-bold font-display text-slate-900 mb-2">Compte activé</h2>
            <p className="text-sm text-slate-500 mb-6">Votre mot de passe a été créé. Vous pouvez maintenant vous connecter.</p>
            <Link to="/login" data-testid="set-password-login-link">
              <Button className="w-full bg-slate-900 hover:bg-slate-800 text-white">Aller à la connexion</Button>
            </Link>
          </div>
        ) : !token ? (
          <div className="text-center" data-testid="set-password-no-token">
            <h2 className="text-2xl font-bold font-display text-slate-900 mb-2">Lien invalide</h2>
            <p className="text-sm text-slate-500">Ce lien de création de mot de passe est incomplet. Demandez un nouveau lien à votre administrateur.</p>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold font-display text-slate-900 mb-1">Créer votre mot de passe</h2>
            <p className="text-sm text-slate-500 mb-6">Définissez le mot de passe de votre compte (6 caractères minimum)</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="pw" className="text-slate-700">Mot de passe</Label>
                <Input id="pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                       data-testid="set-password-input" className="mt-1" />
              </div>
              <div>
                <Label htmlFor="pw2" className="text-slate-700">Confirmer le mot de passe</Label>
                <Input id="pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
                       data-testid="set-password-confirm" className="mt-1" />
              </div>
              {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-lg" data-testid="set-password-error">{error}</div>}
              <Button type="submit" disabled={loading} data-testid="set-password-submit"
                      className="w-full bg-slate-900 hover:bg-slate-800 text-white">
                {loading ? "Activation…" : "Activer mon compte"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
